import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import SpanButton from '../SpanButton';

import s from './ClearButton.module.scss';

type ClearButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  classNameModifier?: string;
};

const ClearButton: FC<ClearButtonProps> = ({
  children = 'Clear changes',
  classNameModifier = '',
  onClick,
  disabled = false,
}) => (
  <SpanButton
    className={getClassName(s, 'root', classNameModifier)}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </SpanButton>
);

export default ClearButton;
